import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useSnackbar } from "../common/snackbar/useSnackbar";
import { colors } from "../ui/colors";
import { SnackbarAlert } from "../common/SnackbarAlert";
import { JobLoadingStatus } from "./JobCreate/JobLoadingStatus";

import { useJobsCreateController } from "./JobCreate/hooks/useJobsCreate";

export const JobOperationStatus = () => {
  const { jobOperationStatus } = useSelector((state) => state.jobState);
  const { error, message } = jobOperationStatus || {};
  const { snackbar, closeSnackbar } = useSnackbar();

  const { handleCreateJob } = useJobsCreateController();

  useEffect(() => {
    const triggerCreation = async () => {
      if (handleCreateJob) {
        await handleCreateJob();
      } else {
      }
    };

    triggerCreation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const status = {
    first: "Services",
    second: "Invoices",
    three: "Quote",
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: "40vh",
        textAlign: "center",
        gap: 3,
      }}
    >
      {!error ? (
        <>{!jobOperationStatus?.captured && <JobLoadingStatus status={status} />}</>
      ) : (
        <Box
          component={motion.div}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}
        >
          <Box
            sx={{
              width: 120,
              height: 120,
              borderRadius: "50%",
              background: `linear-gradient(135deg, ${colors.orange[400]}, ${colors.orange[700]})`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: `0 8px 24px ${colors.orange[200]}`,
            }}
          >
            <ReportProblemIcon sx={{ fontSize: 64, color: "#fff" }} />
          </Box>
          <Typography sx={{ fontSize: "1.2rem", fontWeight: 600, color: colors.gray[800] }}>
            {`${message || "Something went wrong"}. Contact support or try later!`}
          </Typography>
        </Box>
      )}

      <SnackbarAlert openState={snackbar.open} setOpenState={closeSnackbar} severity={snackbar.severity} message={snackbar.message} />
    </Box>
  );
};
